import { BasicProps } from "@components/ComponentsInterface";
import React, { useCallback, useEffect, useState } from "react";

export interface ErrorContext {
    error: ErrorMessageProps | undefined;
    addError: (message: string, title: string) => {};
    removeError: () => {};
}

export const APIErrorContext = React.createContext({
    error: undefined,
    addError: (message: string, title: string) => {},
    removeError: () => {}
} as ErrorContext);

export default function APIErrorProvider({ ...props }: BasicProps): JSX.Element {
    const [error, setError] = useState<ErrorMessageProps>();

    const removeError = (): void => setError(undefined);

    const addError = (message: string, title: string): void => setError({ message, title });

    const contextValue = {
        error,
        addError: useCallback((message: string, title: string) => addError(message, title), []),
        removeError: useCallback(() => removeError(), [])
    } as ErrorContext;

    useEffect(() => {
        removeError();
    }, [location.pathname]);

    return <APIErrorContext.Provider value={contextValue}>{props.children}</APIErrorContext.Provider>;
}

interface ErrorMessageProps {
    message: string;
    title: string;
}
